import { render } from "./SocialIcon.vue?vue&type=template&id=99a64542&scoped=true"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"

import "./SocialIcon.vue?vue&type=style&index=0&id=99a64542&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-99a64542"

export default script